import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import logo from "./images/avaya-onecloud-top-logo.svg";
import footerLogo from "./images/avaya-footer-logo.svg";
import "./ArrowButton.scss";

function ArrowButton({ to, side }: { to: string; side: string }) {
  return (
    <div className={`button-container-${side}`}>
      <Link to={to} className="button-circle drop-shadow"></Link>
    </div>
  );
}

export default ArrowButton;
